<template>
  <b-modal
    ref="addChartModal"
    hide-footer
    centered
    title="Create New Chart"
    size="lg"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Default chart type:"
      >
        <b-form-select
          v-model.trim="$v.defaultChartType.$model"
          :class="{ 'is-invalid': $v.defaultChartType.$error }"
          :disabled="inProgress"
          :options="chartTypes"
        />
        <b-form-invalid-feedback
          v-if="!$v.defaultChartType.required"
          >
          Default chart type is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Chart id:"
      >
        <b-form-input
          type="text"
          v-model.trim="$v.chartId.$model"
          :class="{ 'is-invalid': $v.chartId.$error }"
          :disabled="inProgress"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          v-if="!$v.chartId.required"
          >
          Chart id is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Data expression:"
      >
        <b-form-select
        v-model.trim="$v.dataExp.$model"
        :options="this.dataSourceList"
        :disabled="inProgress"
        ></b-form-select>
        <b-form-invalid-feedback
          v-if="!$v.dataExp.required"
          >
          Data expression is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
// validations
import { required } from 'vuelidate/lib/validators'

let $ = window.$

export default {
  data () {
    return {
      defaultChartType: 'pie',
      chartTypes: [
        { value: 'pie', text: 'Pie' },
        { value: 'bar', text: 'Bar' },
        { value: 'donut', text: 'Donut' },
        { value: 'stacked', text: 'Stacked' },
        { value: 'line', text: 'Line' }
      ],
      chartId: '',
      dataExp: null,
      inProgress: false,
      gsOptions: {}
    }
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab',
      'dataGrid_options',
      'computedProps'
    ]),
    dataSourceList(){
      var list = []
        if (this.dataGrid_options) {
          for (let grid in this.dataGrid_options) {
            const value = `$getGrid('${grid}')`

            if (!this.dataGrid_options[grid]) continue;
            const text = this.dataGrid_options[grid].title

            list.push({ value, text })
          }
        }
        if (this.computedProps) {

          for (let prop in this.computedProps) {
            const value = prop
            const text = "Computed > " + prop

            list.push({ value, text })
          }
        }
      return list
    }


    },

  methods: {
    async save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true
      let vm = this

      this.$store.commit('addProcess', {
        process: 'newDataGrid',
        message: 'Creating'
      })

      const data = {
        defaultChartType: vm.defaultChartType,
        chartId: vm.chartId,
        tab: vm.currentTab,
        subtab: this.currentSubTab || null,
        dataExp: vm.dataExp
      }

      await db.chart.add(data, this.gsOptions);

      this.defaultChartType = 'pie';
      this.chartId = '';
      this.dataExp = null;
      this.inProgress = false;
      this.gsOptions = {};

      this.$store.commit('deleteProcess', 'newDataGrid');

      this.$nextTick(() => {
        this.$v.$reset()
      })

      if (this.$refs.addChartModal) this.$refs.addChartModal.hide()
    }
  },
  validations: {
    defaultChartType: {
      required
    },
    chartId: {
      required
    },
    dataExp: {
      required
    }
  },
  created () {
    eventBus.$on('showAddChartModal', ({gsOptions}) => {
      if (this.$refs.addChartModal) {
        this.gsOptions = gsOptions;
        this.$refs.addChartModal.show()
      }
    })
  },
  mounted () {
    if (this.$refs.addChartModal) {
      $(this.$refs.addChartModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.addChartModal) {
      $(this.$refs.addChartModal['$el']).remove()
    }
  }
}
</script>
